/**
 * SnappiPit web i18n runtime — 11-language launch catalogue.
 *
 * All supported languages use the same complete namespace contract. English is
 * the fallback; availability to end users remains controlled by the backend
 * `active_languages` setting.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enMaster from './locales/en.json';
export const SUPPORTED_LANGUAGES = ['en', 'ar', 'ur', 'hi', 'ml', 'zh', 'fr', 'de', 'es', 'pt', 'tr'];
export const DEFAULT_LANGUAGE = 'en';
export const NAMESPACES = Object.keys(enMaster);

const resources = { en: enMaster };
const languagePromises = {};
const loaders = {
 ar: () => import('./locales/ar.json'), ur: () => import('./locales/ur.json'),
 hi: () => import('./locales/hi.json'), ml: () => import('./locales/ml.json'),
 zh: () => import('./locales/zh.json'), fr: () => import('./locales/fr.json'),
 de: () => import('./locales/de.json'), es: () => import('./locales/es.json'),
 pt: () => import('./locales/pt.json'), tr: () => import('./locales/tr.json'),
};
const languageBackend = {
 type: 'backend', init() {},
 read(language, namespace, callback) {
  const loader = loaders[language];
  if (!loader) { callback(null, enMaster[namespace] || {}); return; }
  if (!languagePromises[language]) languagePromises[language] = loader().catch(error => { delete languagePromises[language]; throw error; });
  languagePromises[language].then(module => callback(null, (module.default || module)[namespace] || {}), error => callback(error, false));
 },
};

if (!i18n.isInitialized) {
  i18n
    .use(languageBackend)
    .use(initReactI18next)
    .init({
      resources,
      partialBundledLanguages: true,
      lng: DEFAULT_LANGUAGE,
      fallbackLng: DEFAULT_LANGUAGE,
      supportedLngs: SUPPORTED_LANGUAGES,
      defaultNS: 'common',
      ns: NAMESPACES,
      interpolation: { escapeValue: false },
      returnNull: false,
      react: { useSuspense: false },
    });
}

export default i18n;
